import React, { useEffect, useState } from "react";
import { toast } from "../../components/AppToast";

import ReturnMDList from "./ReturnMDList";
import CreateReturnMD from "./CreateReturnMD";

import {
    fetchReturnMD,
    createReturnMD,
    updateReturnMD
} from "../../services/returnmd/returnmd.service";

export default function ReturnMDManagement() {

    const [returnData, setReturnData] = useState();

    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    useEffect(() => {
        fetchData();
    }, [page, pageSize]);

    const fetchData = async () => {

        try {

            const result = await fetchReturnMD(page, pageSize);

            setReturnData(result);

        } catch (err) {

            console.error(err);

        }

    };

    const submitForm = async (formData, id) => {

        try {

            if (id) {

                await updateReturnMD(id, formData);

                toast.success("Return rule updated successfully");

            } else {

                await createReturnMD(formData);

                toast.success("Return rule created successfully");

            }

            closeForm();
            fetchData();

        } catch (err) {

            toast.error(err.message);

        }

    };

    return (

        <div className="card shadow-lg main-card">

            {/* Header */}

            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">

                <h4 className="mb-0 h6 fw-semibold">

                    {!onlyFormVisible
                        ? "Return Management"
                        : isCreating
                            ? "Create Return Rule"
                            : activeRecord?.mode === "edit"
                                ? "Edit Return Rule"
                                : "View Return Rule"}

                </h4>

            </div>

            {/* Breadcrumb */}

            {onlyFormVisible && (

                <nav className="px-3 py-2 border-bottom bg-light">

                    <ol className="breadcrumb mb-0">

                        <li className="breadcrumb-item">

                            <button
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Return Management
                            </button>

                        </li>

                        <li className="breadcrumb-item active text-primary fw-semibold">

                            {isCreating
                                ? "Create Return Rule"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Return Rule"
                                    : "View Return Rule"}

                        </li>

                    </ol>

                </nav>

            )}

            {/* Body */}

            <div className="card-body">

                {!onlyFormVisible ? (

                    <ReturnMDList
                        returnData={returnData}
                        page={page}
                        pageSize={pageSize}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) => setActiveRecord({ mode: "view", data: row })}
                        onEdit={(row) => setActiveRecord({ mode: "edit", data: row })}
                        onRefresh={fetchData}
                    />

                ) : (

                    <CreateReturnMD
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />

                )}

            </div>

        </div>

    );

}